module.exports = __webpack_public_path__ + "static/media/rilee-marks-lose.024e909c.jpg";